import React from "react";

const ExpressionNameLookupContext = React.createContext<Record<string, string>>({});
export const Consumer = ExpressionNameLookupContext.Consumer;

export default ExpressionNameLookupContext;
